import { TranslateService } from '@ngx-translate/core';
import { EstensaColDef } from '../search-param.model';
import {
    BoolIconRendererIconType,
} from '../search-result/cell-renderers/bool-icon-renderer/bool-icon-renderer.component';
import { GridUtilitiesService } from '../../services/grid-utilities.service';
import { DiffHeaderComponent } from '../search-result/header-renders/diff-header/diff-header.component';

export function ecgColumnDefs(translate: TranslateService, gridUtils: GridUtilitiesService): EstensaColDef[] {
    return [
        {
            colId: 'lockColId',
            headerName: '',
            tooltipField: '',
            width: 26,
            minWidth: 26,
            suppressSizeToFit: true,
            sortable: false,
            resizable: false,
            lockPosition: true,
            pinned: 'left',
            headerComponent: DiffHeaderComponent,
            cellStyle: { padding: '0', display: 'flex', justifyContent: 'center', width: '26px', left: '' },
            cellRenderer: 'lockUnlockRenderer',
            cellRendererParams: {
                lockedField: 'locked',
                userField: 'lockedUserFullName',
            },
        },
        {
            colId: 'ExamOutOfFlow',
            headerName: '',
            valueGetter: (e) => e.data,
            tooltipField: '',
            width: 26,
            minWidth: 26,
            suppressSizeToFit: true,
            resizable: false,
            lockPosition: true,
            pinned: 'left',
            cellStyle: { padding: '0', display: 'flex', justifyContent: 'center', width: '26px', left: '30px' },
            cellRenderer: 'stateIconRenderer',
            sortable: true,
            comparator: (valueA, valueB) => {
                if (valueA.patient.isLocalPatient && valueB.patient.isLocalPatient) return 0;
                if (!valueA.patient.isLocalPatient && !valueB.patient.isLocalPatient) return 0;
                if (!valueA.patient.isLocalPatient && valueB.patient.isLocalPatient) return 1;

                return -1;
            },
            cellRendererParams: {
                estensa: [
                    {
                        iconType: BoolIconRendererIconType.SeFont,
                        field: 'patient.isLocalPatient',
                        icon: 'icon_flusso_inverso',
                        tooltip: 'PatientDataNotAssociated',
                    },
                    {
                        iconType: BoolIconRendererIconType.AngularMaterial,
                        field: 'reportingWithoutTrace',
                        icon: 'image_not_supported',
                        tooltip: 'ExamWithoutTrace',
                    },
                    {
                        iconType: BoolIconRendererIconType.AngularMaterial,
                        field: 'fromIntegration',
                        icon: 'exit_to_app',
                        fontSize: '18px',
                        tooltip: 'ExternalIntegration',
                    },
                ],
            },
        },
        {
            colId: 'AssociatedVisit',
            headerName: '',
            valueGetter: (e) => e.data,
            width: 26,
            minWidth: 26,
            suppressSizeToFit: true,
            resizable: false,
            sortable: false,
            lockPosition: true,
            pinned: 'left',
            cellStyle: { padding: '0', display: 'flex', justifyContent: 'center', width: '26px', left: '50px' },
            cellRenderer: 'stateIconRenderer',
            cellRendererParams: {
                estensa(data) {
                    if (!data.isEcgReport && data.idReport != null) {
                        return {
                            iconType: BoolIconRendererIconType.AngularMaterial,
                            icon: 'attach_file',
                            fontSize: '20px',
                            tooltip: translate.instant('VisitAndEcg'),
                        };
                    }
                    if (data.examinationsNumber > 1) {
                        return {
                            iconType: BoolIconRendererIconType.SeSvg,
                            icon: 'associations-visit',
                            tooltip: translate.instant('HasAssociatedExaminations'),
                        };
                    }
                },
            },
        },
        {
            colId: '0',
            headerName: translate.instant('Patient'),
            headerTooltip: translate.instant('Patient'),
            valueGetter: (e) =>
                `${e.data.patient.lastName.toLocaleUpperCase()} ${e.data.patient.firstName.toLocaleUpperCase()}`,
            tooltipValueGetter: (e) =>
                `${e.data.patient.lastName.toLocaleUpperCase()} ${e.data.patient.firstName.toLocaleUpperCase()}`,
            width: 220,
            minWidth: 190,
            suppressSizeToFit: true,
            lockPosition: true,
            pinned: 'left',
            cellStyle: (e) => {
                if (e.data.patient.isCertificating === true) return { 'background-color': 'yellow' };
                if (e.data.patient.isCertificating === false && e.data.patient.isCertified === false)
                    return { 'background-color': 'red' };
                return null;
            },
        },
        {
            colId: '1',
            headerName: translate.instant('BirthDate'),
            headerTooltip: translate.instant('BirthDate'),
            tooltipValueGetter: (p) => p.valueFormatted,
            field: 'patient.birthDate',
            width: 180,
            minWidth: 130,
            valueFormatter: gridUtils.dateFormatter(['patient', 'birthDate']),
            comparator: gridUtils.dateComparator,
        },
        {
            colId: '2',
            headerName: translate.instant('ExamDate'),
            headerTooltip: translate.instant('ExamDate'),
            tooltipValueGetter: (p) => p.valueFormatted,
            field: 'examinationDate',
            sort: 'desc',
            width: 150,
            minWidth: 120,
            valueFormatter: gridUtils.dateTimeFormatter('examinationDate'),
            comparator: gridUtils.dateComparator,
        },
        {
            colId: '14',
            headerName: translate.instant('AdmissionDate'),
            headerTooltip: translate.instant('AdmissionDate'),
            tooltipValueGetter: (p) => p.valueFormatted,
            field: 'admissionDate',
            width: 150,
            minWidth: 120,
            valueFormatter: gridUtils.dateTimeFormatter('admissionDate'),
            comparator: gridUtils.dateComparator,
            hide: true,
        },
        {
            colId: '15',
            headerName: translate.instant('RadioDiagnosis'),
            headerTooltip: translate.instant('RadioDiagnosis'),
            tooltipField: 'diagnosis.description',
            field: 'diagnosis.description',
            width: 150,
            minWidth: 120,
            suppressSizeToFit: false,
            hide: true,
        },
        {
            colId: '3',
            headerName: translate.instant('Severity'),
            headerTooltip: translate.instant('Severity'),
            tooltipField: 'severity.description',
            field: 'severity.description',
            cellStyle: (params) => ({
                color:
                    params.data.severity?.color?.toLocaleLowerCase() == 'white'
                        ? 'black'
                        : params.data.severity?.color?.toLocaleLowerCase(),
            }),
            width: 100,
            minWidth: 80,
        },
        {
            colId: '4',
            headerName: translate.instant('Status'),
            headerTooltip: translate.instant('Status'),
            tooltipField: 'status',
            field: 'status',
            width: 80,
            minWidth: 60,
        },
        {
            colId: '5',
            headerName: translate.instant('Provenance'),
            headerTooltip: translate.instant('Provenance'),
            tooltipField: 'provenance.description',
            field: 'provenance.description',
            width: 150,
            minWidth: 120,
        },
        {
            colId: '6',
            headerName: translate.instant('ReferringPhysician'),
            headerTooltip: translate.instant('ReferringPhysician'),
            valueGetter: (e) => gridUtils.getFullName(e.data.referringPhysician),
            tooltipValueGetter: (e) => gridUtils.getFullName(e.data.referringPhysician),
            width: 220,
            minWidth: 190,
        },
        {
            colId: '7',
            headerName: translate.instant('ReportDate'),
            headerTooltip: translate.instant('ReportDate'),
            tooltipValueGetter: (p) => p.valueFormatted,
            field: 'reportDate',
            width: 150,
            minWidth: 120,
            valueFormatter: gridUtils.dateTimeFormatter('reportDate'),
            comparator: gridUtils.dateComparator,
        },
        {
            colId: '8',
            headerName: translate.instant('ExamNumber'),
            headerTooltip: translate.instant('ExamNumber'),
            tooltipField: 'examNumber',
            field: 'examNumber',
            width: 190,
            minWidth: 160,
        },
        {
            colId: '9',
            headerName: translate.instant('Exam'),
            headerTooltip: translate.instant('Exam'),
            tooltipField: 'exam.description',
            field: 'exam.description',
            width: 220,
            minWidth: 190,
        },
        {
            colId: '10',
            headerName: translate.instant('BusinessUnit'),
            headerTooltip: translate.instant('BusinessUnit'),
            tooltipField: 'businessUnit.description',
            field: 'businessUnit.description',
            width: 190,
            minWidth: 150,
        },
        {
            colId: '11',
            headerName: translate.instant('PatientId'),
            headerTooltip: translate.instant('PatientId'),
            tooltipField: 'patient.patientId',
            field: 'patient.patientId',
            width: 190,
            minWidth: 150,
        },
        {
            headerName: translate.instant('Equipment'),
            headerTooltip: translate.instant('Equipment'),
            tooltipField: 'equipment.description',
            field: 'equipment.description',
            colId: '12',
            width: 150,
            minWidth: 120,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('OtherPatientId'),
            headerTooltip: translate.instant('OtherPatientId'),
            tooltipField: 'patient.otherPatientId',
            field: 'patient.otherPatientId',
            colId: '13',
            width: 120,
            minWidth: 100,
            suppressSizeToFit: false,
            hide: false,
        },
    ];
}
